import AccountIcon from "./src/account.svg";
import AdminReadConvosIcon from "./src/admin-read-convos.svg";
import AffirmLogoIcon from "./src/affirm-logo.png";
import AlreadyHasContractorIcon from "./src/already-has-contractor.svg";
import AvatarIcon from "./src/avatar.svg";
import BackyardIcon from "./src/backyard.svg";
import BellIcon from "./src/bell.svg";
import BipocOwnedIcon from "./src/bipoc-owned.svg";
import BlueprintIcon from "./src/blueprint.svg";
import BondedIcon from "./src/bonded.svg";
import BookingFastIcon from "./src/booking-fast.svg";
import BudgetIcon from "./src/budget.svg";
import BuildProjectIcon from "./src/build-projects.svg";
import CalendarMonthIcon from "./src/calendar-month.svg";
import CalendarIcon from "./src/calendar.svg";
import Chat2Icon from "./src/chat-2.svg";
import ChatIcon3 from "./src/chat-3.svg";
import ChatBubble from "./src/chat-bubble.svg";
import ChatOutlineIcon from "./src/chat-outline.svg";
import ChatIcon from "./src/chat.svg";
import Check1Icon from "./src/check-1.svg";
import ChecklistIcon from "./src/checklist.svg";
import CircledCheckIcon from "./src/circled-check.svg";
import ConstructorIcon from "./src/constructor.svg";
import ConversationIcon from "./src/conversation-1.svg";
import CopyIcon from "./src/copy-icon.svg";
import DesignProjectsIcon from "./src/design-projects.svg";
import DiyIcon from "./src/diy.svg";
import EcoFriendlyIcon from "./src/eco-friendly.svg";
import EstimateMatchIcon from "./src/estimateMatchGuarantee.svg";
import EstimatesIcon from "./src/estimates.svg";
import ExteriorHomeIcon from "./src/exterior-home.svg";
import FamilyOwnedIcon from "./src/family-owned.svg";
import FemaleFoundedIcon from "./src/female-founded.svg";
import FiltersIcon from "./src/filters.svg";
import FinishQuicklyIcon from "./src/finish-quickly.svg";
import FreeEstimatesIcon from "./src/free-estimates.svg";
import FrontYardIcon from "./src/front-yard.svg";
import FullYardIcon from "./src/full-yard.svg";
import GoodbyeIcon from "./src/goodbye.svg";
import GuidanceIcon from "./src/guidance.svg";
import HandHoldingHandIcon from "./src/hand-holding-hand.svg";
import HandShakeIcon from "./src/handshake.svg";
import HangingLightIcon from "./src/hanging-light.svg";
import HelmetOutlineIcon from "./src/helmet-outline.svg";
import HelmetIcon from "./src/helmet.svg";
import HelpCenterIcon from "./src/help-center.svg";
import HelpIcon from "./src/help.svg";
import HouseAndBushes from "./src/house-and-bushes.svg";
import LicensedIcon from "./src/licensed.svg";
import LoadingArrows from "./src/loading-arrows.svg";
import LocationMarkerIcon from "./src/location-marker.svg";
import LoginIcon from "./src/login.svg";
import LogoutIcon from "./src/logout.svg";
import MeasuementTapeIcon from "./src/measurement-tape.svg";
import MeterHighIcon from "./src/meter-high.svg";
import MeterLowIcon from "./src/meter-low.svg";
import NoImageAvailable from "./src/no-image-available.svg";
import OwnerOperatorIcon from "./src/owner-operated.svg";
import PhasingIcon from "./src/phasing.svg";
import PhoneIcon from "./src/phone.svg";
import PlanIcon from "./src/plan.svg";
import PlantIcon from "./src/plant.svg";
import PlusIcon from "./src/plus-icon.svg";
import PremiumExperienceIcon from "./src/premium-experience.svg";
import ProPromiseReviewIcon from "./src/pro-promise-review.svg";
import ProPromiseServiceIcon from "./src/pro-promise-service.svg";
import ProPromiseVerifyIcon from "./src/pro-promise-verify.svg";
import LawnInstallation from "./src/project-elements/lawn-installation-grass.svg";
import TurfInstallationIcon from "./src/project-elements/lawn-installation-turf.svg";
import LawnRemoval from "./src/project-elements/lawn-removal.svg";
import PlantingIcon from "./src/project-elements/new-plants.svg";
import TreesIcon from "./src/project-elements/new-trees-and-or-shrubs.svg";
import ProsIcon from "./src/pros.svg";
import QualityContractorIcon from "./src/quality-contractor.svg";
import ResponsiveCommunicationIcon from "./src/responsive-communication.svg";
import SuccessIcon from "./src/success-icon.svg";
import SuperProIcon from "./src/super-pro-badge.svg";
import TapIcon from "./src/tap.svg";
import TextInstructionOneIcon from "./src/text-instruction-one.svg";
import TextInstructionThreeIcon from "./src/text-instruction-three.svg";
import TextInstructionTwoIcon from "./src/text-instruction-two.svg";
import Traditional2DPlansIcon from "./src/traditional-process/2d-plans.svg";
import TraditionalConfusedIcon from "./src/traditional-process/confused.svg";
import TraditionalLockedInIcon from "./src/traditional-process/locked-in.svg";
import TraditionalTimeConsumingIcon from "./src/traditional-process/time-consuming.svg";
import ValueProIcon from "./src/value-pro.svg";
import VeteranOwnedIcon from "./src/veteran-owned.svg";
import ViewEstimateIcon from "./src/view-estimate.svg";
import WandaiIcon from "./src/wandai.svg";
import WarningIcon from "./src/warning-icon.svg";
import WhiteChatIcon from "./src/white-chat-icon.svg";
import WinkIcon from "./src/wink.svg";
import YardzenApprovedIcon from "./src/yardzen-approved.svg";
import YardzenLogoFullIcon from "./src/yardzen-logo-full.svg";
import YardzenLogoMobileIcon from "./src/yardzen-logo-mobile.svg";
import YardzenContractorIcon from "./src/yardzen-process/contractor.svg";
import YardzenDesignTalentIcon from "./src/yardzen-process/design-talent.svg";
import YardzenRelaxedIcon from "./src/yardzen-process/relaxed.svg";
import YardzenRendersIcon from "./src/yardzen-process/renders.svg";
import YardzenIcon from "./src/yardzen.svg";
import YearsInBusinessIcon from "./src/years-in-business.svg";
import YzProHeaderLogoIcon from "./src/yzpro-header-logo.png";

import CuriosityIcon from "./src/careers/icon-curiosity.svg";
import GoodnessIcon from "./src/careers/icon-goodness.svg";
import GritIcon from "./src/careers/icon-grit.svg";
import ImpactIcon from "./src/careers/icon-impact.svg";
import InclusionIcon from "./src/careers/icon-inclusion.svg";
import IntelligenceIcon from "./src/careers/icon-intelligence.svg";
import PassionIcon from "./src/careers/icon-passion.svg";
import VelocityIcon from "./src/careers/icon-velocity.svg";

import QuizAlmostDoneIcon from "./src/quiz-almost-done.svg";
import QuizDreamYard from "./src/quiz-dream-yard.svg";
import QuizStartIcon from "./src/quiz-start.svg";
import QuizTellUsIcon from "./src/quiz-tell-us.svg";
import CactusIcon from "./src/cactus.svg";
import CollectIcon from "./src/collect.svg";
import EntertainIcon from "./src/entertain.svg";
import HouseFenceIcon from "./src/frontyard.svg";
import FireSmartBalancedIcon from "./src/fire-smart-balanced.svg";
import FireSmartDesignerIcon from "./src/fire-smart-designer.svg";
import FireSmartMaximumIcon from "./src/fire-smart-maximum.svg";
import GardenIcon from "./src/garden.svg";
import GoalCookingIcon from "./src/goal-cooking.svg";
import GoalDiningIcon from "./src/goal-dining.svg";
import GoalEntertainingIcon from "./src/goal-entertaining.svg";
import GoalGardenIcon from "./src/goal-garden.svg";
import GoalKidsIcon from "./src/goal-kids.svg";
import GoalPlayingIcon from "./src/goal-playing.svg";
import GoalRelaxingIcon from "./src/goal-relaxing.svg";
import GoalWellnessIcon from "./src/goal-wellness.svg";
import GoalWithTreesIcon from "./src/goal-with-trees.svg";
import KidsIcon from "./src/kids.svg";
import LandscapingIcon from "./src/landscaping.svg";
import PatioIcon from "./src/patio.svg";
import PlantsIcon from "./src/plants.svg";
import RelaxingIcon from "./src/relaxing.svg";
import SeasonalInterestIcon from "./src/seasonal-interest.svg";
import SmallAreaIcon from "./src/small-area.svg";
import WaterIcon from "./src/water.svg";
import WellnessIcon from "./src/wellness.svg";
import WholeYardIcon from "./src/whole-yard.svg";
import AduIcon from "./src/adu.svg";
import ChairsIcon from "./src/chairs.svg";
import ColdplungeIcon from "./src/coldplunge.svg";
import CouchesIcon from "./src/couches.svg";
import FenceIcon from "./src/fence.svg";
import FirepitIcon from "./src/firepit.svg";
import FountainIcon from "./src/fountain.svg";
import HottubIcon from "./src/hottub.svg";
import IngroundIcon from "./src/inground.svg";
import KitchenIcon from "./src/kitchen.svg";
import LoungesIcon from "./src/lounges.svg";
import PendantsIcon from "./src/pendants.svg";
import PergolaIcon from "./src/pergola.svg";
import PlaygroundIcon from "./src/playground.svg";
import PoolIcon from "./src/pool.svg";
import RaisedIcon from "./src/raised.svg";
import SaunaIcon from "./src/sauna.svg";
import SconcesIcon from "./src/sconces.svg";
import ShedIcon from "./src/shed.svg";
import ShrubsIcon from "./src/shrubs.svg";
import SportsIcon from "./src/sports.svg";
import StringIcon from "./src/string.svg";
import TablesIcon from "./src/tables.svg";
import TreeSingleIcon from "./src/tree-single.svg";
import YardMaintenanceIcon from "./src/yard-maintenance.svg";

// Onboarding / yard-feature icons (goals, plant preferences, wishlist
// products) keyed by file name for dynamic lookup from section data.
export const OnboardingIconMap = {
  cactus: CactusIcon,
  collect: CollectIcon,
  entertain: EntertainIcon,
  frontyard: HouseFenceIcon,
  "fire-smart-balanced": FireSmartBalancedIcon,
  "fire-smart-designer": FireSmartDesignerIcon,
  "fire-smart-maximum": FireSmartMaximumIcon,
  garden: GardenIcon,
  "goal-cooking": GoalCookingIcon,
  "goal-dining": GoalDiningIcon,
  "goal-entertaining": GoalEntertainingIcon,
  "goal-garden": GoalGardenIcon,
  "goal-kids": GoalKidsIcon,
  "goal-playing": GoalPlayingIcon,
  "goal-relaxing": GoalRelaxingIcon,
  "goal-wellness": GoalWellnessIcon,
  "goal-with-trees": GoalWithTreesIcon,
  kids: KidsIcon,
  landscaping: LandscapingIcon,
  patio: PatioIcon,
  plants: PlantsIcon,
  relaxing: RelaxingIcon,
  "seasonal-interest": SeasonalInterestIcon,
  "small-area": SmallAreaIcon,
  "tree-single": TreeSingleIcon,
  water: WaterIcon,
  wellness: WellnessIcon,
  "whole-yard": WholeYardIcon,
  adu: AduIcon,
  chairs: ChairsIcon,
  coldplunge: ColdplungeIcon,
  couches: CouchesIcon,
  fence: FenceIcon,
  firepit: FirepitIcon,
  fountain: FountainIcon,
  hottub: HottubIcon,
  inground: IngroundIcon,
  kitchen: KitchenIcon,
  lounges: LoungesIcon,
  pendants: PendantsIcon,
  pergola: PergolaIcon,
  playground: PlaygroundIcon,
  pool: PoolIcon,
  raised: RaisedIcon,
  sauna: SaunaIcon,
  sconces: SconcesIcon,
  shed: ShedIcon,
  shrubs: ShrubsIcon,
  sports: SportsIcon,
  string: StringIcon,
  tables: TablesIcon,
  "yard-maintenance": YardMaintenanceIcon,
} as const;

export type OnboardingIconName = keyof typeof OnboardingIconMap;

export * as MarketingIcons from "@yardzen/components/icons";
export * from "./src/ArrowRight";
export * from "./src/Calendar";
export * from "./src/ChatFilled";
export * from "./src/CircledCheck";
export * as DesignQuizIcons from "./src/design-quiz";
export * from "./src/Download";
export * as FaIcon from "./src/FaIcon";
export * from "./src/NewTabLink/index";
export * as OnboardingWishlistIcons from "./src/onboarding-wishlist";
export * from "./src/PaperAirplane";
export * from "./src/PartyPopper";
export * as ProjectElementsIcons from "./src/project-elements";
export * from "./src/Sweat";
export * from "./src/TooltipInfo";

export {
  CactusIcon,
  CollectIcon,
  EntertainIcon,
  HouseFenceIcon,
  GardenIcon,
  GoalCookingIcon,
  GoalDiningIcon,
  GoalEntertainingIcon,
  GoalGardenIcon,
  GoalKidsIcon,
  GoalPlayingIcon,
  GoalRelaxingIcon,
  GoalWellnessIcon,
  GoalWithTreesIcon,
  KidsIcon,
  LandscapingIcon,
  PatioIcon,
  PlantsIcon,
  RelaxingIcon,
  SeasonalInterestIcon,
  SmallAreaIcon,
  TreeSingleIcon,
  WaterIcon,
  WellnessIcon,
  WholeYardIcon,
  AduIcon,
  ChairsIcon,
  ColdplungeIcon,
  CouchesIcon,
  FenceIcon,
  FirepitIcon,
  FountainIcon,
  HottubIcon,
  IngroundIcon,
  KitchenIcon,
  LoungesIcon,
  PendantsIcon,
  PergolaIcon,
  PlaygroundIcon,
  PoolIcon,
  RaisedIcon,
  SaunaIcon,
  SconcesIcon,
  ShedIcon,
  ShrubsIcon,
  SportsIcon,
  StringIcon,
  TablesIcon,
  YardMaintenanceIcon,
  AccountIcon,
  AdminReadConvosIcon,
  AffirmLogoIcon,
  AlreadyHasContractorIcon,
  AvatarIcon,
  BackyardIcon,
  BellIcon,
  BipocOwnedIcon,
  BlueprintIcon,
  BondedIcon,
  BookingFastIcon,
  BudgetIcon,
  BuildProjectIcon,
  CalendarIcon,
  CalendarMonthIcon,
  Chat2Icon,
  ChatBubble,
  ChatIcon,
  ChatIcon3,
  ChatOutlineIcon,
  Check1Icon,
  ChecklistIcon,
  CircledCheckIcon,
  ConstructorIcon,
  ConversationIcon,
  CopyIcon,
  CuriosityIcon,
  DesignProjectsIcon,
  DiyIcon,
  EcoFriendlyIcon,
  EstimateMatchIcon,
  EstimatesIcon,
  ExteriorHomeIcon,
  FamilyOwnedIcon,
  FemaleFoundedIcon,
  FiltersIcon,
  FinishQuicklyIcon,
  FreeEstimatesIcon,
  FrontYardIcon,
  FullYardIcon,
  GoodbyeIcon,
  GoodnessIcon,
  GritIcon,
  GuidanceIcon,
  HandHoldingHandIcon,
  HandShakeIcon,
  HangingLightIcon,
  HelmetIcon,
  HelmetOutlineIcon,
  HelpCenterIcon,
  HelpIcon,
  HouseAndBushes,
  ImpactIcon,
  InclusionIcon,
  IntelligenceIcon,
  LawnInstallation,
  LawnRemoval,
  LicensedIcon,
  LoadingArrows,
  LocationMarkerIcon,
  LoginIcon,
  LogoutIcon,
  MeasuementTapeIcon,
  MeterHighIcon,
  MeterLowIcon,
  NoImageAvailable,
  OwnerOperatorIcon,
  PhasingIcon,
  PhoneIcon,
  PlanIcon,
  PlantIcon,
  PlantingIcon,
  PlusIcon,
  PassionIcon,
  PremiumExperienceIcon,
  ProPromiseReviewIcon,
  ProPromiseServiceIcon,
  ProPromiseVerifyIcon,
  ProsIcon,
  QualityContractorIcon,
  QuizAlmostDoneIcon,
  QuizDreamYard,
  QuizStartIcon,
  QuizTellUsIcon,
  ResponsiveCommunicationIcon,
  SuccessIcon,
  SuperProIcon,
  TapIcon,
  TextInstructionOneIcon,
  TextInstructionThreeIcon,
  TextInstructionTwoIcon,
  Traditional2DPlansIcon,
  TraditionalConfusedIcon,
  TraditionalLockedInIcon,
  TraditionalTimeConsumingIcon,
  TreesIcon,
  TurfInstallationIcon,
  ValueProIcon,
  VelocityIcon,
  VeteranOwnedIcon,
  ViewEstimateIcon,
  WandaiIcon,
  WarningIcon,
  WhiteChatIcon,
  WinkIcon,
  YardzenApprovedIcon,
  YardzenContractorIcon,
  YardzenDesignTalentIcon,
  YardzenIcon,
  YardzenLogoFullIcon,
  YardzenLogoMobileIcon,
  YardzenRelaxedIcon,
  YardzenRendersIcon,
  YearsInBusinessIcon,
  YzProHeaderLogoIcon,
};
